import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdvisoryModel, IdInterface, TestInterface } from '../data';
import { TestProvider } from '../providers/test.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface GetTestUseCaseParams {
    clientId: IdInterface;
    advisoryModel?: AdvisoryModel;
}

@Injectable()
export class GetTestUseCase implements UseCaseWithParam<GetTestUseCaseParams, Observable<Transaction<TestInterface>>> {
    constructor(private testProvider: TestProvider) {}

    bind(params: GetTestUseCaseParams): Observable<Transaction<TestInterface>> {
        return this.testProvider.find(params.clientId, params.advisoryModel || AdvisoryModel.C).pipe(
            map((transaction) =>
                transaction.map(
                    (test) => Transaction.success(cloneDeep(test)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
